import { render } from "./FormResponse.vue?vue&type=template&id=7f88e2ae"
import script from "./FormResponse.vue?vue&type=script&lang=js"
export * from "./FormResponse.vue?vue&type=script&lang=js"

import "./FormResponse.vue?vue&type=style&index=0&id=7f88e2ae&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__